import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAccessToken } from 'providers/AccessTokenProvider';
import { JOBBOARD_UNAUTHORIZED_EVENT } from 'services/api/base';

const isAuthRoutePath = (pathname: string) => {
  return pathname === '/' || pathname.startsWith('/auth/');
};

const UnauthorizedRedirectListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { invalidateSession } = useAccessToken();

  useEffect(() => {
    const handler = () => {
      // Always clear local session so ProtectedRoute can do its job.
      invalidateSession();

      // If we're already on an auth route, let the current screen handle errors/UI.
      if (isAuthRoutePath(window.location.pathname)) {
        return;
      }

      navigate('/', { replace: true, state: { from: location } });
    };

    window.addEventListener(JOBBOARD_UNAUTHORIZED_EVENT, handler as any);
    return () =>
      window.removeEventListener(JOBBOARD_UNAUTHORIZED_EVENT, handler as any);
  }, [invalidateSession, location, navigate]);

  return null;
};

export default UnauthorizedRedirectListener;
